const storeSearch = {
  currentAjaxRequest: null,

  onFormSearchData($form, searchURL, data) {
    const $resultsList = $form.find('.searchResults');
    $resultsList.empty();

    if (data.results.length <= 0) {
      $resultsList.hide();
    } else {
      $.each(data.results, (index, item) => {
        if (index <= 6) {
          const $link = $('<a>').attr('href', item.url);

          $link.append(`
              <span class="thumbnail">
                <img src="${item.thumbnail}">
              </span>
              <div class="productInfo">
              <div class="title">${item.title}</div>
              <div class="category">${item.product_type}</div>
              </div>
            `);
          $link.wrap('<li>');

          $resultsList.append($link.parent());
        }
      });

      if (data.results_count > 7) {
        $resultsList.append(`
            <li class="more">
              <a class="btn btn--full btn--smaller center" href="${searchURL}">
                All search results (${data.results_count})
              </a>
            </li>
          `);
      }

      $resultsList.fadeIn(200);
    }
  },

  onSearchInputUpdate(e) {
    const $input = $(e.currentTarget);
    const $form = $input.closest('form');
    const term = $input.val();

    const searchURL = `/search?type=product&q=${term}*`;
    const $resultsList = $form.find('.searchResults');
    const $clearInput = $form.find('.clearInput');
    const $resultLoader = $form.find('.resultLoader');

    if (term.length >= 2 && term !== $input.attr('data-old-term')) {
      $input.attr('data-old-term', term);

      if (this.currentAjaxRequest) {
        this.currentAjaxRequest.abort();
        $resultLoader.hide();
      }

      $resultLoader.show();
      $clearInput.show();

      this.currentAjaxRequest = $.getJSON(`${searchURL}&view=json`, data => {
        // Track
        // Segment.track('Products Searched', {
        //   query: term,
        // })

        // Results
        this.onFormSearchData($form, searchURL, data);
      }).always(() => {
        $resultLoader.hide();
      });
    } else if (term.length <= 1) {
      $resultsList.hide();
      $clearInput.hide();
    }
  },

  init() {
    $('.queryText').val(
      $('.queryText')
      .val()
      .replace('*', ''),
    );

    $('input[name="mockup"]').each((i, inputEl) => {
      $(inputEl)
        .val(
          decodeURIComponent(
            $(inputEl)
            .val()
            .replace('*', ''),
          ),
        )
        .addClass('ready');
    });

    $('form.search').each((i, formEl) => {
      const $form = $(formEl);
      const $input = $form.find('input[name="mockup"]');

      $('<ul class="searchResults">')
        .appendTo($form)
        .hide();

      $input
        .prop('autocomplete', false)
        .on('keyup change', this.onSearchInputUpdate.bind(this));
    });

    $('body').on('click', () => {
      $('.searchResults').hide();
    });

    $('form.search').submit(e => {
      const $mockup = $(e.currentTarget).find('input[name="mockup"]');

      $('.queryText').val(`${$mockup.val()}*`);
    });

    $('.clearInput').on('click', e => {
      $(e.currentTarget).siblings('.inputText').val('').focus();
      $(e.currentTarget).hide();
    });

    $(document).on('click', '.comGlobalSearch__toggle', e => {
      e.preventDefault();
      $('.comGlobalSearch, .comGlobalSearch__toggle').toggleClass('active');
      $('.inputText').focus();
    });

  },
};

$(() => {
  storeSearch.init();
});
